import {
  Breadcrumbs,
  filtersToGraphQLFilters,
  PageViewModeEnum,
  PageViewModeToolbar,
  useDataExplorerReportStore,
} from '@diana/core';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsFetching } from '@tanstack/react-query';
import { useBreadcrumbsRoot } from '../../hooks/useBreadcrumbsRoot';
import { ROUTES_NS } from '../../i18n/routes';
import { getDataExplorerGraphQLWorksQueryKey } from './Support';
import { PERFORMANCE_PAGE_NS } from './i18n';

export const HeaderLeft = memo(() => {
  const { t } = useTranslation([ROUTES_NS, PERFORMANCE_PAGE_NS]);

  const breadcrumbRoot = useBreadcrumbsRoot('performance');
  return <Breadcrumbs items={[breadcrumbRoot, { title: t('routes:dataExplorer') }]} />;
});

export const HeaderRight = (props: { setIsExportModalOpen: (param: boolean) => void }) => {
  const { setIsExportModalOpen } = props;

  const filtersValues = useDataExplorerReportStore((store) => store.filtersValues);
  const availableFilters = useDataExplorerReportStore((store) => store.availableFilters);
  const viewMode = useDataExplorerReportStore((store) => store.viewMode);
  const setViewMode = useDataExplorerReportStore((store) => store.setViewMode);

  const isFetchingWorkboardWorks = useIsFetching({
    queryKey: getDataExplorerGraphQLWorksQueryKey(
      filtersToGraphQLFilters({
        filters: availableFilters,
        filtersValues,
      }),
    ),
  });

  return (
    <PageViewModeToolbar
      viewMode={viewMode}
      onViewChange={setViewMode}
      isCsvButtonDisabled={isFetchingWorkboardWorks > 0}
      onCsvClick={
        viewMode === PageViewModeEnum.Table ? () => setIsExportModalOpen(true) : undefined
      }
    />
  );
};
